class SizeManager {
  public get docSize(): number {
    return this._docSize
  }

  public static getInstance = () => {
    if (!SizeManager.instance) {
      SizeManager.instance = new SizeManager()
    }
    return SizeManager.instance
  }

  private static instance: SizeManager
  private _docSize: number
  private docElem: Element

  private constructor() {
    this.docElem = document.documentElement
    this._docSize = this.getFontSize()
    window.addEventListener('resize', () => {
      this._docSize = this.getFontSize()
    })
  }

  private getFontSize = (): number =>
    Number.parseInt(window.getComputedStyle(this.docElem).fontSize || '', 10)
}

export const docSize = () => SizeManager.getInstance().docSize

export default SizeManager



// WEBPACK FOOTER //
// ./src/services/sizes.ts